/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderWeightingTransparencyTypes = 'Hidden' | 'Reduced' | 'Detailed';

export const TenderWeightingTransparencyTypes = {
    Hidden: 'Hidden' as TenderWeightingTransparencyTypes,
    Reduced: 'Reduced' as TenderWeightingTransparencyTypes,
    Detailed: 'Detailed' as TenderWeightingTransparencyTypes
};

